import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { tap, shareReplay, map, filter, retry, catchError } from 'rxjs/operators';
import { environment as env } from '@env/environment'
import { Observable } from 'rxjs';
import { Jwt } from '@models/jwt.model';
import { JwtService } from './jwt.service';

@Injectable({
    providedIn: 'root'
})
export class AuthService {

    constructor(private http: HttpClient) { }

    public get(auth: string) : Observable<Jwt> ;
    public get(usr: string, pwd: string) : Observable<Jwt> ;

    public get(auth: string, pwd?: string) : Observable<Jwt> {

        JwtService.clear();

        if(pwd !== undefined) {
            auth = 'BASIC ' + btoa(auth + ":" + pwd);
        }

        let headers = new HttpHeaders({
            'Content-Type':'application/json',
            'Authorization': auth
        });
        
        return this.http.get<Jwt>(env.API_URL + '/jwt', {headers: headers});
    }

    /*
    public refresh() {

        let jwt = Jwt.get();
        let exp = new Date(1000 * jwt.payload.exp);
        let now = new Date();
        let ts = (exp.getTime() - now.getTime())/60000; //minutes left for jwt to expire
        
        if( ts <= 30) { 
            //if less than 30 minutes to expire then refresh it
            this.get(jwt.auth).subscribe( 
                (data : Jwt) => {}, 
                error => {}
            );
        }
    }
    */
}

